var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "projects-sidebar-menu" }
    },
    [
      _c("div", { attrs: { id: "new-project-frame" } }, [
        _c(
          "div",
          {
            staticClass: "red-pill-button-of-hate",
            on: { click: _vm.createNewProject }
          },
          [_vm._v("Новый проект")]
        )
      ]),
      _vm._v(" "),
      _c("label", { attrs: { id: "project-search-label" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.mask,
              expression: "mask"
            }
          ],
          attrs: {
            type: "text",
            id: "project-search",
            placeholder: "Найти проект"
          },
          domProps: { value: _vm.mask },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.mask = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm.projectSelected
        ? _c("div", [
            _c("div", { staticClass: "sidebar-sub-label" }, [
              _vm._v("Название проекта:")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sidebar-text" }, [
              _c("span", { staticClass: "project-name" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.nameActiveProject) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "project-stats" }, [
              _c("div", { staticClass: "sidebar-stat-name stripe" }, [
                _vm._v("Количество фотографий:")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-stat-val stripe" }, [
                _vm._v(_vm._s(_vm.numberPhotos))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-stat-name" }, [
                _vm._v("Количество дизайнов:")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-stat-val" }, [
                _vm._v(_vm._s(_vm.numberDesigns))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-stat-name stripe" }, [
                _vm._v("Количество стен:")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-stat-val stripe" }, [
                _vm._v(_vm._s(_vm.getNumberPlanesByType("wall")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-stat-name" }, [
                _vm._v("Количество окон:")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-stat-val" }, [
                _vm._v(_vm._s(_vm.getNumberPlanesByType("window")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-stat-name stripe" }, [
                _vm._v("Количество дверей:")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-stat-val stripe" }, [
                _vm._v(_vm._s(_vm.getNumberPlanesByType("door")))
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }